'use client';

import { PublicPageLayout } from '@letsgo/PublicPageLayout';
import Link from 'next/link';
import { Box, Container, Typography, Button, Card, CardContent } from '@mui/material';
import { Code, Security, Speed } from '@mui/icons-material';

const DevelopersPage = () => {
  return (
    <PublicPageLayout>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h3" fontWeight={700} mb={2} color="text.primary" component="h1">
          API &amp; Developer Resources
        </Typography>
        <Typography variant="h6" color="text.secondary" mb={4}>
          Build integrations, automate workflows, and extend FloAI Studio for developers, partners, and enterprises.
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 6 }}>
          <Typography variant="body1" color="text.primary">
            Our API gives you programmatic access to content, scheduling, analytics, and more. Use it to power custom dashboards, 
            white-label experiences, or internal tools. Authenticate with API keys or OAuth; respect rate limits and our terms of use.
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Card variant="outlined" sx={{ flex: '1 1 260px', maxWidth: 360 }}>
              <CardContent>
                <Code color="primary" sx={{ mb: 1 }} />
                <Typography variant="subtitle1" fontWeight={700} gutterBottom>REST API</Typography>
                <Typography variant="body2" color="text.secondary">
                  Standard REST endpoints for content, calendar, and account operations. JSON request/response.
                </Typography>
              </CardContent>
            </Card>
            <Card variant="outlined" sx={{ flex: '1 1 260px', maxWidth: 360 }}>
              <CardContent>
                <Security color="primary" sx={{ mb: 1 }} />
                <Typography variant="subtitle1" fontWeight={700} gutterBottom>Auth &amp; Keys</Typography>
                <Typography variant="body2" color="text.secondary">
                  API key or OAuth 2.0. Scoped permissions per app. Keys are available in dashboard settings for Pro/Enterprise.
                </Typography>
              </CardContent>
            </Card>
            <Card variant="outlined" sx={{ flex: '1 1 260px', maxWidth: 360 }}>
              <CardContent>
                <Speed color="primary" sx={{ mb: 1 }} />
                <Typography variant="subtitle1" fontWeight={700} gutterBottom>Rate Limits</Typography>
                <Typography variant="body2" color="text.secondary">
                  Tiered limits by plan. Headers indicate remaining quota. Contact us for higher limits or SLA.
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
          <Button
            component={Link}
            href="/contact?subject=api-access"
            variant="contained"
            color="primary"
            size="large"
          >
            Request API Access
          </Button>
          <Button component={Link} href="/support" variant="outlined" color="primary" size="large">
            View Support &amp; Docs
          </Button>
        </Box>
      </Container>
    </PublicPageLayout>
  );
};

export default DevelopersPage;
